import { z } from '@harvestiq/zod';
import { dbFaqSchema } from './db-faq';

export const faqSchema = dbFaqSchema.extend({
  slug: z.string().optional(),
});

export type Faq = z.infer<typeof faqSchema>;
